<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ propertyTitle }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link :to="propertiesListPath">{{ propertiesListLabel }}</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ propertyTitle }}</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <PropertiesForm v-if="!mainLoading && checkAccess('property_update')" 
              :cardTitle="propertyTitle" 
              :dataRow="row" 
              :currentUserContainers="containers"
            />
            <PropertiesView v-if="!mainLoading && !checkAccess('property_update')" 
              :cardTitle="propertyTitle" 
              :dataRow="row" 
              :statusChoices="statusChoices" 
            />
            <AdminNotesPanel
              v-show="!mainLoading"
              modelName="Properties"
              :recordId="id"
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import PropertiesForm from './form.vue';
import PropertiesView from './view.vue';
import AdminNotesPanel from '../admin_notes/adminNotesPanel.vue';

export default {
  name: 'PropertiesUpdate',
  components: {
    PropertiesForm, PropertiesView, AdminNotesPanel,
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      propertyTitle: 'تعديل عقار',
      row: null,
      statusChoices: {},
      containers: [],
    }
  },
  computed: {
    propertiesListPath(){
      if(this.$route.query.from === 'companyProperty') return '/companyProperty';
      if(this.$route.query.from === 'archive') return '/properties/archive';
      return '/properties';
    },
    propertiesListLabel(){
      if(this.$route.query.from === 'companyProperty') return 'عقارات الشركة';
      if(this.$route.query.from === 'archive') return 'أرشيف العقارات';
      return 'العقارات';
    },
  },
  methods: {
    checkAccess,
    getRowData(){
      this.$http.get(`/api/admin/properties/retrieve/${this.id}`).then(({data}) => {
        this.propertyTitle = data.property.title;
        this.row = data.property;
        this.statusChoices = data.statusChoices;
        this.containers = data.containers;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    this.getRowData();
  }
}
</script>
